<template>
    <div class="home">
        <periods />
    </div>
</template>

<script>
    import Periods from "../components/views/Periods";
    export default {
        name: "PeriodsView",
        components: {Periods}
    }
</script>

<style scoped>

</style>
